/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Stack,
  Box,
} from '@mui/material';
import {
  Card,
  ProfileCardContent,
  LabelAndValueElement,
  ContextMenuComplete,
  useCurrentTime,
  ZAvatar,
} from '@marageti/z4-lib';
import { RoleName } from '@marageti/z4-sdk/lib/auth';
import { ProfileCardProps } from './types';
import styles from './styles';
import { getPhoneNumber, formatTimeWithTimeZoneName } from '../../../../utils/helpers';

const roleDisplayNames: Partial<Record<RoleName, string>> = {
  [RoleName.ADMIN]: 'Admin',
  [RoleName.CARE]: 'Care',
  [RoleName.DATA]: 'Data',
  [RoleName.MARKETING]: 'Marketing',
  [RoleName.PARTNERSHIPS]: 'Partnerships',
  [RoleName.PHOTO]: 'Photo',
};

const getRoleDisplayName = (roles: RoleName[] | null): string => {
  if (!roles || roles.length === 0) return '';
  return roles.map((role) => roleDisplayNames[role]).join(', ');
};

const ProfileCard = ({
  contextMenuProps,
  isAdmin,
  onEditAvatar,
  teamMember,
  user,
}: ProfileCardProps) => {
  const [time] = useCurrentTime(teamMember?.timeZone?.name);

  return (
    <Card sx={styles.profileCard}>
      <ProfileCardContent>
        <Box sx={styles.avatarBoxDesktop}>
          <ZAvatar
            name={teamMember?.fullName}
            size={128}
            loading={!teamMember}
            onEdit={onEditAvatar}
            src={teamMember?.avatar}
          />
        </Box>
        <Stack spacing="24px" width="100%">
          <Stack direction="row" justifyContent="space-between">
            <LabelAndValueElement
              title="Name"
              value={teamMember?.fullName}
              key="name"
            />
            {isAdmin && <ContextMenuComplete {...contextMenuProps} />}
          </Stack>
          <LabelAndValueElement
            title="Email"
            value={teamMember?.email}
            key="email"
          />
          <LabelAndValueElement
            title="Phone"
            value={getPhoneNumber(teamMember)}
            key="phone"
          />
          <LabelAndValueElement
            title="Timezone"
            value={teamMember?.timeZone ? formatTimeWithTimeZoneName(teamMember?.timeZone, time) : '-'}
            key="timeZone"
          />
          <LabelAndValueElement
            title="Role"
            value={getRoleDisplayName(user?.roles || teamMember?.userInfo[0]?.roles || null)}
            key="role"
          />
        </Stack>
      </ProfileCardContent>
    </Card>
  );
};

export default ProfileCard;
